import { DateTime } from "luxon";

const getTicketEta = (ticket = {}) => {
  let eta;
  if (ticket?.status === "scheduled") {
    eta = DateTime.local().plus({days: ticket?.estimated_time_to_complete}).toLocaleString()
  } else if (ticket?.status === "completed") {
    eta = DateTime.local().toLocaleString()
  } else {
    eta = DateTime.fromISO(ticket?.accepted_at).plus({days: ticket?.estimated_time_to_complete}).toLocaleString();
  }
  return eta;
};

export { getTicketEta };